import React from "react";
import { Box, Typography } from "@mui/material";
import MyContainer from "../../../MyContainer";
import ArticleCard from "../../../ui/ArticleCard";
import { useRelatedArticlesSectionStyles } from "./RelatedArticlesSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useCommerceData } from "../../../../hooks/useCommerceData";
import { commerceRepository } from "../../../../api";

interface RelatedArticlesSectionProps {
    handle: string;
}

const RelatedArticlesSection = (props: RelatedArticlesSectionProps) => {
    const { classes } = useRelatedArticlesSectionStyles();
    const { t } = useI18n();
    const { data } = useCommerceData(() => commerceRepository.getRelatedArticles(props.handle, 3), [props.handle]);

    if (!data || data.length === 0) {
        return null;
    }

    return (
        <Box className={classes.root}>
            <MyContainer>
                <Typography variant="h2" className={classes.title}>{t("blogArticlePage.relatedArticlesTitle")}</Typography>
                <Box className={classes.grid}>
                    {data.map((article) => (
                        <ArticleCard key={article.id} article={article} />
                    ))}
                </Box>
            </MyContainer>
        </Box>
    );
};

export default RelatedArticlesSection;
